import { useRouter } from 'expo-router'
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { ScaledSheet } from 'react-native-size-matters'
import {
  ChatLayoutOneByOne,
  ChatLayoutOneByThree,
  ChatLayoutOneByTwo,
  ChatLayoutTwoByThree,
  ChatLayoutTwoByTwo,
} from '~components/ChatLayoutImages'
import { FormButton } from '~components/FormButton'
import ModalScreen, { getModalStyleDefinition, ModalFooter } from '~components/ModalScreen'
import { useTheme } from '~theme/ThemeManager'
import { ChatLayoutOption } from '~types'
import { actions, useNewChatContext } from './state'

export default function EmptyLayout() {
  const styles = useStyles()
  const [state, stateDispatch] = useNewChatContext()
  const router = useRouter()

  const layout = (layout: ChatLayoutOption) => stateDispatch(actions.setLayout(layout))

  const layouts: ChatLayoutOption[][] = [
    [
      { rows: 1, columns: 1, image: <ChatLayoutOneByOne /> },
      { rows: 1, columns: 2, image: <ChatLayoutOneByTwo /> },
      { rows: 1, columns: 3, image: <ChatLayoutOneByThree /> },
    ],
    [
      { rows: 2, columns: 2, image: <ChatLayoutTwoByTwo /> },
      { rows: 2, columns: 3, image: <ChatLayoutTwoByThree /> },
    ],
  ]

  const dismiss = React.useCallback(() => {
    stateDispatch(actions.reset())
  }, [stateDispatch])

  return (
    <ModalScreen
      onDismiss={dismiss}
      dismissTo={state.dismissTo}
      Footer={
        <ModalFooter>
          <FormButton
            onPress={router.back}
            title={'Back'}
            style={styles.backButton}
            textStyle={styles.backButtonText}
            disabled={state.loading}
          />
          <FormButton
            onPress={() => router.navigate('./details')}
            title={'Continue'}
            style={styles.button}
            disabled={state.layout === undefined}
          />
        </ModalFooter>
      }
    >
      <View style={styles.inner}>
        <View style={styles.content}>
          {/* {progress(1)} */}

          <View style={styles.titleContainer}>
            <Text style={styles.title}>Blank layout</Text>
            <Text style={styles.subtitle}>Choose from one of the layouts below</Text>
          </View>

          {layouts.map((items, row) => (
            <View style={styles.layoutsContainer} key={`layout-row-${row}`}>
              {items.map((item, index) => (
                <TouchableOpacity onPress={() => layout(item)} key={`layout-${row}-${index}`}>
                  <View
                    style={[
                      styles.listItem,
                      item.rows === state.layout?.rows &&
                        item.columns === state.layout.columns &&
                        styles.listItemSelected,
                    ]}
                  >
                    {item.image}
                  </View>
                </TouchableOpacity>
              ))}
            </View>
          ))}
        </View>
      </View>
    </ModalScreen>
  )
}

const useStyles = () => {
  const { theme, mode } = useTheme()
  return ScaledSheet.create({
    ...getModalStyleDefinition(theme, mode),
    listItem: {
      marginVertical: '5@mvs',
      padding: '5@ms',
      backgroundColor: theme.white,
    },
    listItemSelected: {
      backgroundColor: theme.pink[200],
    },
    layoutsContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    backgroundContainerStyle: {
      borderColor: theme.primary,
    },
    textContainerStyle: {
      borderColor: theme.primary,
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      paddingTop: '10@mvs0.8',
      paddingStart: '15@ms',
      paddingHorizontal: '10@mvs0.8',
    },
    folderInput: {
      color: theme.primary,
    },
  })
}
